// tslint:disable-next-line:no-var-requires
const _ = require('lodash');

import { CarrierId } from '@/@types/carrierId';

export class Carrier {
  public id: CarrierId;
  public name: string;
  public typeName: string;
  public applicationFee: number;
  public simComissionFee: number;
  // tslint:disable-next-line:max-line-length
  constructor(
    id: CarrierId,
    name: string,
    typeName: string,
    applicationFee: number,
    simComissionFee: number
  ) {
    this.id = id;
    this.name = name;
    this.typeName = typeName;
    this.applicationFee = applicationFee;
    this.simComissionFee = simComissionFee;
  }
}
